// Teinte stable dérivée de l'uid, pour que chaque campagne garde sa couleur.
const CAMPAIGN_HUES = [210, 255, 300, 340, 15, 170, 140, 190];

export const getCampaignHue = (campaignUid) => {
  const key = campaignUid || '';
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return CAMPAIGN_HUES[hash % CAMPAIGN_HUES.length];
}

export const getCampaignInitials = (name) => (name || '')
  .split(/\s+/)
  .filter(Boolean)
  .slice(0, 2)
  .map(word => word[0].toUpperCase())
  .join('');
